import { cn } from "~/lib/utils";

export type ProjectAutomationStatusTone = "ready" | "running" | "failed" | "neutral";

export function ProjectAutomationStatusDot({
  tone,
}: {
  readonly tone: ProjectAutomationStatusTone;
}) {
  return (
    <span
      aria-hidden
      className={cn(
        "size-2 shrink-0 rounded-full",
        tone === "ready" ? "bg-success" : null,
        tone === "running" ? "bg-hue-sky" : null,
        tone === "failed" ? "bg-destructive" : null,
        tone === "neutral" ? "bg-muted-foreground/40" : null,
      )}
    />
  );
}
